module.exports = __webpack_public_path__ + "img/kings_campus.79639d2d.png";